import React, { Component } from 'react'

class ProposalMilestonesPreview extends Component {
  renderMilestone = (milestone, index) => {
    return <li key={index}>{milestone.description}</li>
  }
  render() {
    const { milestonesDataStructure } = this.props

    return (
      <ol type="1">
        {milestonesDataStructure && milestonesDataStructure.map(this.renderMilestone)}
      </ol>
    )
  }
}

export default ProposalMilestonesPreview



// WEBPACK FOOTER //
// ./src/components/templates/ProposalMilestonesPreview.js